class CustomSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
    this.flkty = null;
    this.sliderButtons = null;
  }

  connectedCallback() {
    this.slider = this.querySelector("[data-custom-slider]");
    this.sliderButtons = this.querySelectorAll("[data-custom-slider-button]");

    if (this.slider && typeof Flickity !== "undefined" && !Flickity.data(this.slider)) {
      const configAttr = this.slider.getAttribute("data-flickity-config") || this.slider.getAttribute("data-flickity");
      let options = {};
      if (configAttr) {
        try {
          options = JSON.parse(configAttr);
        } catch (e) {
          console.error("Flickity config parsing error:", e);
        }
      }
      
      const flkty = new Flickity(this.slider, options);
      
      flkty.on("ready", () => this.matchHeight());
      flkty.on("change", () => this.matchHeight());
      
      // Ensure the slider is properly sized
      flkty.resize();
      this.matchHeight();
      
      window.addEventListener("resize", () => this.matchHeight());
      
      setTimeout(() => {
        flkty.resize();
        this.matchHeight();
      }, 200);
    }

    this.sliderButtons.forEach((button) => {
      button.addEventListener("click", this.handleButtonClick.bind(this));
    });
  }

  matchHeight() {
    const cards = this.querySelectorAll(".resource-list__item");
    if (!cards.length) return;

    let maxHeight = 0;

    // Reset heights to calculate natural height
    cards.forEach((card) => {
      card.style.height = "auto";
    });

    // Find the tallest card
    cards.forEach((card) => {
      const height = card.offsetHeight;
      if (height > maxHeight) maxHeight = height;
    });

    // Apply the max height to all cards
    cards.forEach((card) => {
      card.style.height = maxHeight + "px";
    });
    
    // Resize Flickity to account for new heights
    const flkty = Flickity.data(this.slider);
    if (flkty) flkty.resize();
  }

  handleButtonClick(event) {
    const flkty = Flickity.data(this.slider);
    const type = event.currentTarget.dataset.type;
    if (type === "prev") {
      flkty.previous();
    } else if (type === "next") {
      flkty.next();
    }
  }
}

customElements.define("custom-slider", CustomSlider);
